import React, { useContext } from 'react';

import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';
import { ExtranetPackStatus } from 'app/typings/core/extranet/hotel/packs';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useReadOnlyRowConfig } from '../../../../../hooks/useReadOnlyRowConfig';
import type { PackDetails } from '../../../../../utils/packs';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { StatusCell } from '../../../../Table/Cells/StatusCell/StatusCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';
import { getStatusInfo } from '../../../inventoryStatusUtils';
import { formatExperienceName } from '../../../tabViewUtils';

const PackStatusRowComponent: React.FC<{ packId: number }> = ({ packId }) => {
  const { experiencesList } = useContext(ModernHotelContext);
  const { data: experiencesCategories } = useExperiencesCategories();

  const { inventoryPacks, dateKeys } = useReadOnlyRowConfig(
    InventoryTabItemName.Packs
  );

  if (!inventoryPacks) {
    return null;
  }

  return (
    <TableRow isHeader>
      <LabelCell label="Status" />
      {dateKeys.map((dateKey) => {
        const fieldName = [dateKey, `${packId}`];

        return (
          <PureFieldCell key={dateKey} name={fieldName} dateKey={dateKey}>
            {(values?: PackDetails) => {
              const statusInfo = values ? getStatusInfo(values) : undefined;

              const experienceIdsInError =
                values && values?.message === 'MISSING_EXPERIENCES_STOCK'
                  ? values.messageReferencedIds ?? []
                  : [];

              const experienceListWithError = experiencesList.filter(
                (experience) => experienceIdsInError.includes(experience.id)
              );

              const listOfExperienceNames = experienceListWithError
                .map((experience) => {
                  const category = experiencesCategories?.find(
                    (cat) => cat.id === experience.categoryId
                  );

                  return formatExperienceName(experience, category?.name);
                })
                .join(', ');

              const tooltipText =
                statusInfo?.label +
                (listOfExperienceNames ? `: ${listOfExperienceNames}` : '');

              return (
                <StatusCell
                  status={
                    values?.inventoryStatus ?? ExtranetPackStatus.PUBLISHED
                  }
                  tooltipText={tooltipText}
                  name={fieldName}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const PackStatusRow = React.memo(PackStatusRowComponent);
